<template>
  <div class="TripSelections">
    <TripDisplay
      v-for="trip of trips"
      :key="trip.id"
      class="TripSelections-item"
      :icon="icon"
      :departureDate="new Date(trip.departure.date.utc)"
      :departureTimezone="trip.departure.date.zoneId"
      :departureLocation="trip.departure.station.code"
      :arrivalDate="new Date(trip.arrival.date.utc)"
      :arrivalTimezone="trip.arrival.date.zoneId"
      :arrivalLocation="trip.arrival.station.code"
      :carrier="trip.carrier.name"
      :seatsLeft="trip.availability.seatsRemaining"
      :price="trip.pricing.summary.total"
      :returnTrip="trip.id === trips[1]?.id"
      :segments="trip.segments"
      :stops="trip.stops"
      :connections="trip.connections"
      showDate
      showTripData
      summary
      edit
      @edit="emit('edit', trip)"
    />
  </div>
</template>

<script setup lang="ts">
import TripDisplay from '../TripDisplay/TripDisplay.vue';
import type { TripSelectionsEmits, TripSelectionsProps } from './TripSelections.model';

defineProps<TripSelectionsProps>();
const emit = defineEmits<TripSelectionsEmits>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .TripSelections {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-4;
    margin-top: vars.$dimensions-d-6;
  }
}
</style>
